import Button from "common/Buttons/Button";
import Text from "common/Typography/Text";
import RouterLink from "common/Buttons/RouterLink";
import { BASE_REGISTER_PATH, LOGIN_PATH } from "common/constants";
import Flex from "common/Boxes/Flex";
import React, { CSSProperties } from "react";

interface AuthFormFooterProps {
  buttonLoading: boolean;
  buttonText?: string;
  buttonStyle?: CSSProperties;
  isRegister?: boolean;
}

const AuthFormFooter = ({
  buttonLoading,
  buttonText: propsButtonText,
  buttonStyle,
  isRegister,
}: AuthFormFooterProps) => {
  const buttonText = isRegister ? "Register" : "Login";
  const linkText = isRegister ? "Login" : "Register";
  const text = isRegister
    ? "Already have an account?"
    : "Don’t have an Account?";
  const path = isRegister ? LOGIN_PATH : BASE_REGISTER_PATH;

  return (
    <Flex $flexDirection="column">
      <Button
        type="primary"
        $size="l"
        htmlType="submit"
        loading={buttonLoading}
        style={{
          width: "100%",
          ...buttonStyle,
        }}
      >
        {propsButtonText || buttonText}
      </Button>
      <Text style={{ marginTop: 20 }}>
        {text} <RouterLink to={path}>{linkText}</RouterLink>
      </Text>
    </Flex>
  );
};

export default AuthFormFooter;
